import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-page-content',
  template: '<ng-content />',
  styleUrls: ['page-content.component.scss']
})
export class PageContentComponent {
}
